import styled, { css } from 'styled-components';

import { queries } from "../../../../breakpoints"

export const Headline = styled.h4`
    font-size: var(--fontSize-3);
    font-weight: bold;
    cursor: pointer;
    
    &:not(:first-of-type){
        margin-top: 10px; 
    }
    svg{
        transition: all .24s;
        margin-left: 10px;
        path{ 
            opacity: 0.4;
            transform: rotate(90deg);
            transform-origin: center;
            transition: all .24s;
            fill: #000000;
        }
    }
    &.active-acc{
        svg{
            path{
            opacity: 1;
                transform: rotate(-90deg);
                transform-origin: center;
                fill: var(--color-primary);
            }
        }
        &:hover{
            svg{
                transform: translateY( -4px );
                
            }
        }
    }
    &:hover:not(.active-acc) > svg{
        transform: translateY( 4px );
        path{
            opacity: 1;
        }
    }
    &.active-acc + .accordion-content{
        display: flex;
    }
`;

export const StyledTopicsSidebar = styled.div` 
    display:none;
    @media(${queries.min_break_md}){
        display:flex;
        flex-flow:column;
        padding:0 1.8rem 2rem 0;
    }
    .accordion-content{
        display: none;
        flex-direction: column;
        
    }
  
    h4{
        font-size: 1.25rem;
        font-weight: 400;
        &:not(:first-child){
          margin-top: 24px;
        }
    }

      button {
        margin-left: 12px;
        transition: all .24s;
    
        /*font-family: var(--scandia-fontFamily);
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0px;
        text-align: left;*/
    
      }
`;

export const Topic = styled.button`
    border:none;
    background-color:white;
    margin: 5px 0;
    display:inline-block;
    transition: all .24s;
    color: #6B6B83;
    
    font-family: var(--scandia-fontFamily);
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0px;
    text-align: left;
    
    
    &:not(.active):hover{
        color:var(--color-primary);
    }
    
    ${props => props.active && css`
        font-weight: bold;
        font-weight: 700;
        color: #000000;
    `}
`;

export const MobileTopics = styled.div`
    width:100%;
    display:flex;
    @media(${queries.min_break_md}){
        display:none;
    }
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{
        border-color: var(--color-primary);
    }
    .MuiFormLabel-root.Mui-focused{
        color: var(--color-primary);
    }
    .MuiPaper-root,
    .MuiMenuItem-root,
    .MuiMenuItem-root,
    .MuiInputBase-root{
      font-family: Scandia Regular !important;
    }
`;
